import { METHODS_FOR_DOORS_LOG } from './constants';

const getBuildings = (state) => state?.buildings || {};
const getBuildingsList = (state) => {
  const buildings = state?.buildingsList || [];
  if (Array.isArray(buildings)) return buildings;
  if (Object.values(buildings).length) return Object.values(buildings);
  return [];
};

const getBuildingById = (state, buildingId) =>
  getBuildings(state)?.[buildingId] || {};
const getBuildingDoors = (state, buildingId) =>
  getBuildingById(state, buildingId)?.doors || [];
const getBuildingCommonDoors = (state, buildingId) =>
  getBuildingDoors(state, buildingId)?.filter(
    ({ isUnitDoor }) => isUnitDoor === false,
  );
const getBuildingDoorsLog = (state, buildingId) =>
  getBuildingById(state, buildingId)?.doorsOpeningLog || [];
const getIsDoorsAndCamerasDisplayed = (state, buildingId) =>
  getBuildingById(state, buildingId)?.isDoorsAndCamerasDisplayed;
const getBuildingResidents = (state, buildingId) =>
  getBuildingById(state, buildingId)?.residents || [];
const getBuildingStaff = (state, buildingId) =>
  getBuildingById(state, buildingId)?.staff || [];

const getDoorOpeningMethodName = (source) => {
  if (!source) return 'Not specified';
  return (
    METHODS_FOR_DOORS_LOG.find(({ value }) => source === value)?.label ??
    'Not specified'
  );
};

const getBuildingStaffById = (state, buildingId, staffId) =>
  getBuildingById(state, buildingId)?.personDetails?.[staffId] || {};
const getBuildingResidentById = (state, buildingId, residentId) =>
  getBuildingById(state, buildingId)?.personDetails?.[residentId] || {};
const getBuildingAccessControlAccounts = (state, buildingId) =>
  getBuildingById(state, buildingId)?.accessControlAccounts;

const getPinnedBuildings = (state) => state?.common?.pinnedBuildings || [];

export {
  getBuildings,
  getBuildingsList,
  getBuildingById,
  getBuildingDoors,
  getBuildingCommonDoors,
  getBuildingDoorsLog,
  getIsDoorsAndCamerasDisplayed,
  getBuildingResidents,
  getBuildingStaff,
  getDoorOpeningMethodName,
  getBuildingStaffById,
  getBuildingResidentById,
  getBuildingAccessControlAccounts,
  getPinnedBuildings,
};
